import { render, staticRenderFns } from "./MaintenanceItemTypeForm.vue?vue&type=template&id=9b6e322c&scoped=true"
import script from "./MaintenanceItemTypeForm.vue?vue&type=script&lang=ts"
export * from "./MaintenanceItemTypeForm.vue?vue&type=script&lang=ts"
import style0 from "./MaintenanceItemTypeForm.vue?vue&type=style&index=0&id=9b6e322c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6e322c",
  null
  
)

export default component.exports